'use strict';

var position = angular.module('saturn.dialog.position', [
  'saturn.utils'
]);

var PositionService = require('./PositionService');

position.service('sbPositionService', [
  '$document',
  '$window',
  'sbPositionUtil',
  PositionService
]);


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/dialog/src/position/index.js